// extracted by mini-css-extract-plugin
module.exports = {"readMore":"ProductDescription_readMore__fQngn"};